import React from 'react';
import styled from 'styled-components';
import { SectionName, SectionTitle } from '../common/styles';

const Container = styled.div`
  margin: ${props => (props.theme.isMobile ? '67px 0 19px 19px' : '0 auto')};
  padding-bottom: 6px;
  max-width: 1230px;
  width: 85vw;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const Timestamp = styled(SectionName)`
  font-size: 12px;
`;

export const Title = styled(SectionTitle)`
  margin: 6px 0 0 0;
  line-height: 40px;
  border-bottom: 1px dashed ${props => props.theme.primaryColor};
  font-size: ${props => (props.theme.isMobile ? 25 : 40)}px;
`;

export const Div = styled.div`
  position: relative;
  max-width: 1180px;
  width: 82vw;
  color: ${props => props.theme.bodyColor};
  font-size: 16px;
  line-height: 25px;
  text-align: left;

  ol > li::marker {
    font-weight: ${props => props.theme.fontWeightBold};    
  }
`;

export const Headline = styled(Div)`
  font-size: 20px;
  font-weight: ${props => props.theme.fontWeightBold};
  margin-top: 33px;
`;

export default function Content() {
  return (
    <Container>
      {/* eslint-disable max-len */}
      {/* eslint react/jsx-one-expression-per-line: 0 */}
      <Timestamp>Updated 9 Feb 2023</Timestamp>
      <Title>Livewire Markets – Editorial Content Policy</Title>
      <Headline />
      <Div>
        <p>
          Livewire is an investing website connecting investors with some of the best fund management and wealth management professionals from Australia and around the world.
        </p>
        <p>
          The Livewire audience is a highly engaged group of more than 280,000 active users who visit the website each month. It comprises financial advisers, high net worth investors, self-managed super fund members, family offices, stockbrokers, and retail investors.
        </p>
      </Div>
      <Headline>What’s in it for the reader?</Headline>
      <Div>
        <p>
          Before creating any content, we expect everyone to consider: What benefit will the reader get from this?
        </p>
      </Div>
      <Headline>Twice-daily sub-editing</Headline>
      <Div>
        <p>
          All articles authored internally are reviewed by at least one member of our editorial team before publication.
        </p>
        <p>
          All contributed articles – from either authorised contributors or official partners – are checked for accuracy during our regular twice-daily sub-editing process.
        </p>
        <p>
          The following are the guiding principles you should consider before publishing anything on Livewiremarkets.com:
        </p>
        <ol>
          <li><strong>Accuracy –</strong> To make accurate investment decisions, you need accurate data. Our share price data come from the Australian Securities Exchange (ASX).  The performance and fees information for our funds database is sourced from Morningstar Australia.</li>
          <li><strong>Readability and Accessibility –</strong> Jargon, buzzwords, and confusing acronyms are everywhere within the world’s financial industry landscape. We don’t seek to add to this clutter. At Livewire Markets, we aim to provide stories that are simple and concise. When acronyms or key terms are needed, we try to provide clear, useful definitions.</li>
          <li><strong>Deeper insights –</strong> We’re not interested in repeating headlines or echoing company talking points. Instead, we dive deeper. We look to fund manager experts, broker reports, and sector trends to go beneath the surface and provide you with the highest quality coverage possible. We link to reputable external sites when they enhance our readers’ understanding of a topic. We don’t want to capture your attention, we want to provide you with the information you need, regardless of where it is.</li>
          <li><strong>High journalistic standards –</strong> We carefully select our writers and are committed to providing them with regular professional development. We teach them best practices for research, sourcing, and writing, and all content is reviewed to meet our standards of clarity, accuracy, and usefulness.</li>
          <li><strong>Transparency –</strong> Whenever we publish content that is promotional in nature, this is clearly identified near the top of the article or video post. When we partner with brands and companies in featuring content in our daily EDM, a &quot;Sponsored&quot; tag is placed at the top of the article, right underneath the headline.</li>
        </ol>
      </Div>
      <Headline>Continual improvement</Headline>
      <Div>
        <p>
          We’re not here to bombard you with irrelevant information for the sake of information. We’re here to give you concise, data-driven market news.
        </p>
        <p>
          If you think we could do better, please send us an email with your suggestions to <a href="mailto:content@livewiremarkets.com">content@livewiremarkets.com</a>.
        </p>
      </Div>
    </Container>
  );
}
